import React, { useEffect, useRef, useState } from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import SEO from "../../components/SEO";
import { color, motion, transform, useInView } from "framer-motion";
import Link from "../../components/v2/Link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import clsx from "clsx";

import BanImg1 from "../../images/v4/user-based-tools/messagingCommunication/images/BanImg1.webp";
import BanImg2 from "../../images/v4/user-based-tools/messagingCommunication/images/BanImg2.webp";
import BanImg3 from "../../images/v4/user-based-tools/messagingCommunication/images/BanImg3.webp";
import BanImg4 from "../../images/v4/user-based-tools/messagingCommunication/images/BanImg4.webp";
import BanImg5 from "../../images/v4/user-based-tools/messagingCommunication/images/BanImg5.webp";
import BanImg6 from "../../images/v4/user-based-tools/messagingCommunication/images/BanImg6.webp";

import adaptImg1 from "../../images/v4/salesManagers/clientSlider/img1.png";
import adaptImg2 from "../../images/v4/salesManagers/clientSlider/img2.png";
import adaptImg3 from "../../images/v4/salesManagers/clientSlider/img3.png";
import adaptImg4 from "../../images/v4/salesManagers/clientSlider/img4.png";
import adaptImg5 from "../../images/v4/salesManagers/clientSlider/img5.png";
import adaptImg6 from "../../images/v4/salesManagers/clientSlider/img6.png";
import adaptImg7 from "../../images/v4/salesManagers/clientSlider/img7.png";

import benefitIcon1 from "../../images/v4/user-based-tools/messagingCommunication/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/user-based-tools/messagingCommunication/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/user-based-tools/messagingCommunication/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/user-based-tools/messagingCommunication/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/user-based-tools/messagingCommunication/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/user-based-tools/messagingCommunication/icons/benefitIcon6.svg";

import compareItemImg1 from "../../images/v4/whatsappCatalogue/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg5 from "../../images/v4/salesReps/topcrm/freshsale.png";

import broadcastImg1 from "../../images/v4/user-based-tools/messagingCommunication/images/broadcastImg1.webp";
import broadcastImg2 from "../../images/v4/user-based-tools/messagingCommunication/images/broadcastImg2.webp";
import broadcastImg3 from "../../images/v4/user-based-tools/messagingCommunication/images/broadcastImg3.webp";
import broadcastImg4 from "../../images/v4/user-based-tools/messagingCommunication/images/broadcastImg4.webp";
import broadcastImg5 from "../../images/v4/user-based-tools/messagingCommunication/images/broadcastImg5.webp";

import experienceImg from "../../images/v4/user-based-tools/messagingCommunication/images/experienceImg.webp";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";

import salesReppageHerobg from "../../images/v4/TgPages/marketting/heroBg.png";
import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import clientbg from "../../images/v4/TgPages/salesDevReps/clientBg.png";

import benefitSectionBg from "../../images/v4/user-based-tools/messagingCommunication/images/benefitSectionBg.png";
import heroSectionBg from "../../images/v4/user-based-tools/messagingCommunication/images/heroSectionBg.png";
import broadcastBg from "../../images/v4/user-based-tools/messagingCommunication/images/broadcastBg.png";
import combineSectionBg from "../../images/v4/user-based-tools/messagingCommunication/images/combineSectionBg.png";
import compareBg from "../../images/v4/user-based-tools/messagingCommunication/images/compareBg.png";
import experienceBg from "../../images/v4/user-based-tools/messagingCommunication/images/experienceBg.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";

const useStyles = makeStyles((theme) => ({
  SalesRepSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${heroSectionBg})`,
    backgroundColor: "#210538",
    backgroundPosition: "center",
    "@media only screen and (max-width: 1440px)": {
      backgroundPosition: "top",
    },
  },
  salesRepContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "20px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "32px",
    "& h1": {
      margin: "0",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .bannerDescription": {},
  },
  Client: {
    position: "relative",
    zIndex: "10",
    backgroundImage: `url(${clientbg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    "@media(max-width:1024px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "25px!important",
        },
      },
    },

    "@media(max-width:600px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "20px!important",
        },
      },
    },

    "& p": {
      textAlign: "center",
      marginBottom: "64px",
      "@media(max-width:1024px)": {
        marginBottom: "32px",
      },

      "@media(max-width: 600px)": {
        marginBottom: "18px",
      },
    },
    "& .client-logo": {
      width: "auto!important",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "35px",
      },
    },
  },
  benefitSection2: {
    backgroundImage: `url(${benefitSectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      "& h2": {
        width: "100%",
      },
      "& p": {
        textAlign: "left",
        width: "40%",
      },
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        gap: "16px",
        "& h2": {
          width: "100%",
          textAlign: "left",
        },
        "& p": {
          textAlign: "left",
          width: "100%",
        },
      },
    },
  },
  benefitContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "stretch",
    gap: "24px",
    rowGap: "24px",
    margin: "60px 0 0",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  benefitBox: {
    display: "flex",
    border: "1px solid #208EEC",
    background: "rgba(32, 142, 236, 0.15)",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    width: "32%",
    padding: "24px",
    borderRadius: "16px",
    transition: "0.3s ease",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "12px",
      padding: "16px",
    },
    // "&:hover": {
    //   transition: "0.3s ease",
    //   background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
    //   "@media only screen and (max-width: 600px)": {
    //     "&:hover": {
    //       background: "transparent",
    //     },
    //   },
    // },
  },
  accordianTabs: {
    position: "relative",
    paadingBottom: "0",
    "& .headercenterContainer": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "64px",
      gap: "20px",
      textAlign: "center",
      "& h2": {
        width: "100%",
      },
      "& p": {
        width: "70%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "20px",
        marginBottom: "55px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
  },
  experienceContainer: {
    backgroundImage: `url(${experienceBg})`,
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      marginTop: "0",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "25px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#1D6FB6",
      marginBottom: "20px",
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
      "& .exp-desc": {
        marginBottom: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "0px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 768px)": {
      // display: "none",
      width: "100%",
      minHeight: "unset",
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  faqBoxAccordian: {
    padding: "0 16px",
    backgroundColor: "transparent",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "& h3": {
      color: "#0A2035",
      opacity: "0.7",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "2px",
      height: "100%",
      background: "rgba(0, 0, 0, 0.30)",
    },
    "&:before": {
      borderRadius: "0 0 4px 4px",
      content: '""',
      position: "absolute",
      background: "linear-gradient(180deg,#B1DBFF 0%, #fff 0%, #0089FF 100% )",
      left: "-1px",
      top: "0",
      width: "4px",
      height: "100%",
      transform: "scaleY(0)",
      transformOrigin: "top",
      zIndex: 1,
    },
    "&.active": {
      "& h3": {
        color: "#0A2035",
        opacity: "1",
      },
      "&:before": {
        animation: "growTimer 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${combineSectionBg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    maxWidth: "1200px",
    margin: "0 auto 32px",

    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "8px",
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",

    "& img": {
      width: "24px",
      height: "24px",
    },

    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  broadcastContainer: {
    backgroundImage: `url(${broadcastBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $broadcastRightContainer": {
      width: "40%",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
      "& $broadcastRightContainer": {
        width: "100%",
      },
    },
  },
  workflowBroadcastContainerInner: {
    width: "100%",
    display: "flex",
    position: "relative",
    alignItems: "stretch",
    gap: "30px",
    padding: "0 4rem 4rem !important",
    overflow: "auto",
    justifyContent: "flex-start",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px 40px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "0 19rem 6rem !important",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  broadcastBox: {
    display: "flex !important",
    padding: "40px",
    background: "#009249",
    alignItems: "center",
    borderRadius: "20px",
    justifyContent: "space-between",
    minWidth: "70%",
    maxWidth: "70%",
    minHeight: "400px",
    maxHeight: "400px",
    // minHeight: "415px",
    // maxHeight: "415px",
    transition: "0.3s ease",
    overflow: "hidden",
    "&.active": {
      transform: "scale(1) !important",
    },
    "&.inActive": {
      transform: "scale(0.8) !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px",
      gap: "15px",
      flexDirection: "column",
      minHeight: "750px",
      justifyContent: "space-between",
      minWidth: "90%",
      maxWidth: "90%",
    },
    "@media only screen and (min-width: 1800px)": {
      minWidth: "80%",
      maxWidth: "80%",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "55%",
    gap: "10px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "flex-start",
    },
  },
  compareSection: {
    backgroundImage: `url(${compareBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "top",
    paddingTop: "280px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "160px",
    },
  },
}));

const MessagingCommunication = () => {
  const classes = useStyles();

  const bannerlogotrack2 = [
    { img: BanImg1, alt: "Omnichannel CRM for multi-platform management" },
    { img: BanImg2, alt: "Unified CRM for all channels" },
    { img: BanImg3, alt: "CRM system integrates communications" },
  ];
  const bannerlogotrack3 = [
    { img: BanImg4, alt: "WhatsApp business integration in CRM" },
    { img: BanImg5, alt: "Connect WhatsApp to CRM software" },
    { img: BanImg6, alt: "How to link WhatsApp CRM" },
    // { img: BanImg7 },
    // { img: BanImg8 },
  ];
  const clientList = [
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
  ];
  const benefits = [
    {
      title: "Omnichannel visibility",
      desc: "Manage WhatsApp, Facebook Messenger, Instagram, WeChat, and Telegram conversations from a unified CRM inbox.",
      icon: benefitIcon1,
    },
    {
      title: "Comprehensive channel",
      desc: "Deep, built-in support for WhatsApp, Facebook Messenger, Instagram, WeChat, and Telegram within the CRM.",
      icon: benefitIcon2,
    },
    {
      title: "Real-time analytics",
      desc: "Get real-time insights on response times, team performance, customer engagement, and campaign impact—across all channels.",
      icon: benefitIcon3,
    },
    {
      title: "Smart automation",
      desc: "Automate tasks with smart workflows — auto-respond, assign chats, and escalate issues.",
      icon: benefitIcon4,
    },
    {
      title: "Enterprise-grade security",
      desc: "Ensure data security with encryption, role-based access, and compliance-grade infrastructure.",
      icon: benefitIcon5,
    },
    {
      title: "Mobile CRM",
      desc: "Manage chats, assign leads, and stay connected on the go with real-time access via Android and iOS apps.",
      icon: benefitIcon6,
    },
  ];

  useEffect(() => {
    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".banner-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "top";
        if (this.track) {
          this.init();
        }
      }

      init() {
        // Store original children so we always clone from a clean copy
        const originalItems = Array.from(this.track.children).map((child) =>
          child.cloneNode(true)
        );
        if (!originalItems.length) return;

        const containerHeight = this.row.offsetHeight;
        let currentHeight = this.track.offsetHeight;

        // Fill until track height is at least twice container height
        while (currentHeight < containerHeight * 2) {
          originalItems.forEach((clone) => {
            this.track.appendChild(clone.cloneNode(true));
          });
          currentHeight = this.track.offsetHeight;
        }

        // Set initial scroll position
        if (this.direction === "top") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetHeight / 2;
        }

        this.animate();
      }

      animate() {
        const animateStep = () => {
          if (this.direction === "top") {
            this.position -= this.speed;
            if (this.position <= -this.track.offsetHeight / 2) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            if (this.position >= 0) {
              this.position = -this.track.offsetHeight / 2;
            }
          }
          this.track.style.transform = `translateY(${this.position}px)`;
          requestAnimationFrame(animateStep);
        };

        requestAnimationFrame(animateStep);
      }
    }

    if (typeof window !== "undefined") {
      document.querySelectorAll(".logos-row").forEach((row) => {
        const speed = parseFloat(row.dataset.speed) || 0.5;
        new InfiniteScroll(row, speed);
      });
    }
  }, []);

  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const AUTO_PLAY_INTERVAL = 10000;
  const sectionRef = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });

  const experienceList = [
    {
      title: "Centralised communication",
      alt: "Omnichannel CRM for WhatsApp, Messenger, and more",
      desc: "Bring all chats into one platform with omnichannel CRM—including CRM with WhatsApp integration and CRM for Facebook Messenger.",
    },
    {
      title: "Boost engagement",
      alt: "Faster customer replies from one CRM",
      desc: "Respond faster on WhatsApp, Messenger, and Instagram—all in one CRM to deliver timely, seamless customer experiences.",
    },
    {
      title: "Increase team productivity",
      alt: "Automated workflows and assignments",
      desc: "Automate workflows, assign tasks instantly, and cut manual effort to empower your team to do more in less time.",
    },
    {
      title: "Gain data-driven insights",
      alt: "Analytics for all messaging channels",
      desc: "Understand messaging performance across every channel with meaningful analytics to guide continuous improvement.",
    },
    {
      title: "Improve lead conversion",
      alt: "Lead nurturing with integrated messaging",
      desc: "Accelerate lead nurturing and follow-up with integrated messaging channels, helping your team convert more leads, faster.",
    },
  ];

  useEffect(() => {
    let interval;

    const startAutoplay = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        setActiveAccordian((prev) => (prev + 1) % experienceList.length);
      }, AUTO_PLAY_INTERVAL);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAutoplay();
        } else {
          clearInterval(interval);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      clearInterval(interval);
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [experienceList.length]);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track?.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo-2");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row-2").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const compareItems = [
    "Pepper Cloud CRM",
    "Zoho CRM",
    "HubSpot CRM",
    "Salesforce",
    "Freshsales CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud is a leading omnichannel CRM with advanced messaging integration across WhatsApp, Facebook Messenger, Instagram, WeChat, and Telegram. Built to unify conversations, it helps businesses engage customers at scale.",
      img: compareItemImg1,
      alt: "Pepper Cloud CRM",
      features: [
        {
          title: "All-in-one messaging inbox",
          desc: "Access and respond to all customer chats within a unified interface—boosting speed and collaboration.",
        },
        {
          title: "Real-time insights",
          desc: "Track message delivery, response rates, and customer engagement across each channel to fine-tune your communication strategy.",
        },
        {
          title: "AI-powered messaging",
          desc: "Get smart reply suggestions, automate FAQs with chatbots, and analyse sentiment to improve interaction quality.",
        },
        {
          title: "Workflow automation",
          desc: "Automate greetings, reminders, escalations, and re-engagements across channels using custom triggers and workflows.",
        },
        {
          title: "Scalable omnichannel support",
          desc: "Connect WhatsApp, Facebook Messenger, Instagram, WeChat, Telegram, and more for seamless communication at scale.",
        },
        {
          title: "Get started",
          desc: "",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM provides a powerful CRM messaging integration that supports various messaging platforms, including WhatsApp and Facebook Messenger. With Zoho CRM, businesses can automate workflows, engage customers in real-time, and manage customer conversations from a single platform.",
      img: compareItemImg2,
      alt: "Zoho CRM",
      features: [
        {
          title: "Multi-channel messaging support",
          desc: "Integrated messaging for WhatsApp, Facebook Messenger, and more directly within the CRM.",
        },
        {
          title: "Automation tools",
          desc: "Trigger real-time responses and personalised communication with flexible automation tools.",
        },
        {
          title: "Centralised dashboard",
          desc: "Track and manage every customer conversation from a single, unified dashboard.",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM is known for its user-friendly interface and robust omnichannel CRM integration, supporting platforms like WhatsApp and Facebook Messenger. It enables teams to streamline communication and boost customer engagement.",
      img: compareItemImg3,
      alt: "HubSpot CRM",
      features: [
        {
          title: "Automated and personalised messaging flows",
          desc: "Built-in tools to automate and personalise communication for every contact.",
        },
        {
          title: "Seamless platform switching",
          desc: "Effortlessly move between messaging channels to maintain continuous conversations.",
        },
        {
          title: "Comprehensive reporting",
          desc: "Measure, analyse, and optimise outreach with powerful analytics and reporting.",
        },
      ],
    },
    {
      title: "Salesforce CRM",
      desc: "Salesforce CRM offers a scalable CRM messaging integration suite connecting to platforms like WhatsApp, Facebook Messenger, and Instagram messaging. It helps large and growing businesses enhance communication and data management.",
      img: compareItemImg4,
      alt: "Salesforce CRM",
      features: [
        {
          title: "Extensive messaging app support",
          desc: "Integrate and manage WhatsApp, Messenger, and Instagram messaging within the CRM interface.",
        },
        {
          title: "Advanced automation & lead routing",
          desc: "Automate workflows and route leads intelligently to maximise speed and efficiency.",
        },
        {
          title: "Deep analytics",
          desc: "Analyse engagement, streamline team collaboration, and optimise messaging ROI with advanced analytics.",
        },
      ],
    },
    {
      title: "Freshsales CRM",
      desc: "Freshsales CRM enables seamless CRM messaging integration with platforms like WhatsApp and Facebook Messenger, making it a reliable tool for real-time engagement.",
      img: compareItemImg5,
      alt: "Freshsales CRM",
      features: [
        {
          title: "Integrated inbox",
          desc: "Manage multi-channel messaging with ease using a single, centralised inbox.",
        },
        {
          title: "AI-driven lead scoring and workflows",
          desc: "Leverage intelligent automation to speed up responses and prioritise customer interactions.",
        },
        {
          title: "Customisable chat templates",
          desc: "Use ready-made or custom templates for chat and follow-ups to resolve queries faster.",
        },
      ],
    },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const faqs = [
    {
      question: "What is omnichannel CRM and why is it important?",
      answer: (
        <>
          An Omnichannel CRM is a platform that centralises messaging across
          apps like WhatsApp, Facebook Messenger, Instagram, WeChat, and
          Telegram—enabling businesses to deliver consistent, personalised
          conversations that boost customer satisfaction and loyalty.
        </>
      ),
    },
    {
      question:
        "What are best practices for using omnichannel CRM effectively?",
      answer: (
        <>
          Organise chats with consistent tags, keep contact data clean, automate
          common workflows, integrate with business tools, and always follow
          privacy regulations.
        </>
      ),
    },
    {
      question: "How does Pepper Cloud help with messaging integration?",
      answer: (
        <>
          Pepper Cloud offers seamless Omnichannel CRM integration so you can
          send, receive, and track messages across all major platforms like
          WhatsApp, Messenger, and Instagram from a single inbox.
        </>
      ),
    },
    {
      question: "Which platforms does Pepper Cloud support?",
      answer: (
        <>
          Pepper Cloud CRM integrates with WhatsApp, Facebook Messenger,
          Instagram messaging, WeChat, and Telegram, ensuring complete
          omnichannel communication.
        </>
      ),
    },
    {
      question: "Can I manage all customer messages from one inbox?",
      answer: (
        <>
          Yes. Pepper Cloud’s unified inbox helps teams collaborate and respond
          to conversations from WhatsApp, Messenger, and more—all in one place.
        </>
      ),
    },
    {
      question: "How does CRM with WhatsApp integration work?",
      answer: (
        <>
          With CRM with WhatsApp integration, you can automate messages, send
          updates, share catalogs, and track conversations—all inside your CRM
          system.
        </>
      ),
    },
    {
      question: "How to integrate WhatsApp with CRM?",
      answer: (
        <>
          To integrate WhatsApp with a CRM like Pepper Cloud, connect your
          WhatsApp Business API to the CRM through its integrations panel. Once
          linked, you can send and receive messages, automate replies, share
          product catalogs, and manage all WhatsApp chats from a unified inbox
          with real-time tracking and workflow automation.
        </>
      ),
    },
  ];

  const bannerPoints = [
    "Manage leads, chats, and sales in one place.",
    "Automate tasks for faster, smarter engagement.",
    "Convert chats into deals with real-time messaging.",
  ];

  const broadcastList = [
    {
      heading: "WhatsApp CRM integration",
      content:
        "Deliver rich, real-time communication using CRM with WhatsApp integration. Send updates, promotional content, and support responses directly from your CRM.",
      img: broadcastImg1,
      alt: "Facebook Messenger CRM system integration",
      link: "/whatsapp-crm/",
      background: "linear-gradient(180deg, #053333 0%, #009A99 100%)",
      points: [
        "One-to-one messages or broadcast messages",
        "Automate lead capture and bookings via WhatsApp",
        "Share product catalogs and media-rich messages",
      ],
    },
    {
      heading: "Messenger CRM integration",
      content:
        "With CRM for Facebook Messenger, streamline all customer queries, promotions, and relationship-building efforts into one integrated platform.",
      img: broadcastImg5,
      alt: "Integrate Messenger with CRM tools",
      link: "/crm-integrations/best-facebook-messenger-crm-integration/",
      background: "linear-gradient(180deg, #31114B 0%, #783CA8 100%)",
      points: [
        "Enable direct messaging from within the CRM",
        "Share product details and timely updates",
        "Automate replies with AI chatbots and flows",
      ],
    },
    {
      heading: "Instagram CRM integration",
      content:
        "Use omnichannel CRM to manage Instagram messaging directly. Respond in real-time, strengthen your brand identity, and visualise communication workflows.",
      img: broadcastImg3,
      alt: "WhatsApp automated replies in CRM",
      link: "/crm-integrations/instagram-crm-for-sales/",
      background: "linear-gradient(180deg, #014957 0%, #028BA6 100%)",
      points: [
        "Rich media messaging from within CRM",
        "Real-time message and resolution tracking",
        "Instagram integration for messaging features",
      ],
    },
    {
      heading: "WeChat CRM integration",
      content:
        "Expand globally with seamless WeChat CRM connectivity inside Pepper Cloud. Engage customers, manage conversations, and track sales — all from one unified platform.",
      img: broadcastImg4,
      alt: "CRM supports omnichannel messaging",
      link: "https://blog.peppercloud.com/wechat-crm-integration-complete-guide/",
      background: "linear-gradient(180deg, #053333 0%, #009A99 100%)",
      points: [
        "Centralise WeChat chats in your CRM",
        "Automate reminders and follow-ups",
        "Localise your messaging strategy with data insights",
      ],
    },
    {
      heading: "Telegram CRM integration",
      content:
        "Manage Telegram conversations with ease using Pepper Cloud omnichannel CRM- chat, tag, assign, and store messages securely in one unified inbox.",
      img: broadcastImg2,
      alt: "WhatsApp chat tracking via CRM",
      link: "/crm-integrations/telegram-social-media/",
      background: "linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      points: [
        "Stay connected with Telegram users from one CRM",
        "Respond instantly with pre-approved templates",
        "Automate follow-ups and group chats effortlessly",
      ],
    },
  ];

  return (
    <main>
      <SEO
        keywords="Omnichannel CRM, CRM with WhatsApp integration, CRM for Facebook Messenger, How to integrate WhatsApp with CRM"
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={
          "Seamless Omnichannel CRM: WhatsApp, IG, WeChat & Telegram Ready"
        }
        description={
          "Connect with customers on every messaging channel—WhatsApp, Instagram, Facebook Messenger, WeChat, and Telegram. Pepper Cloud CRM centralises chats, automates tasks, and delivers real-time insights for better sales growth."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is omnichannel CRM and why is it important?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "An Omnichannel CRM is a platform that centralises messaging across apps like WhatsApp, Facebook Messenger, Instagram, WeChat, and Telegram—enabling businesses to deliver consistent, personalised conversations that boost customer satisfaction and loyalty.",
                },
              },
              {
                "@type": "Question",
                name: "What are best practices for using omnichannel CRM effectively?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Organise chats with consistent tags, keep contact data clean, automate common workflows, integrate with business tools, and always follow privacy regulations.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud help with messaging integration?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud offers seamless Omnichannel CRM integration so you can send, receive, and track messages across all major platforms like WhatsApp, Messenger, and Instagram from a single inbox.",
                },
              },
              {
                "@type": "Question",
                name: "Which platforms does Pepper Cloud support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM integrates with WhatsApp, Facebook Messenger, Instagram messaging, WeChat, and Telegram, ensuring complete omnichannel communication.",
                },
              },
              {
                "@type": "Question",
                name: "Can I manage all customer messages from one inbox?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Pepper Cloud’s unified inbox helps teams collaborate and respond to conversations from WhatsApp, Messenger, and more—all in one place.",
                },
              },
              {
                "@type": "Question",
                name: "How does CRM with WhatsApp integration work?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "With CRM with WhatsApp integration, you can automate messages, send updates, share catalogs, and track conversations—all inside your CRM system.",
                },
              },
              {
                "@type": "Question",
                name: "How to integrate WhatsApp with CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "To integrate WhatsApp with a CRM like Pepper Cloud, connect your WhatsApp Business API to the CRM through its integrations panel. Once linked, you can send and receive messages, automate replies, share product catalogs, and manage all WhatsApp chats from a unified inbox with real-time tracking and workflow automation.",
                },
              },
            ],
          },
        ]}
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
      />
      <section className={classes.SalesRepSection}>
        <div className="carouselContainer">
          <div className={classes.salesRepContainer}>
            <div className={classes.salesSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64 font-white "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Chat smarter with omnichannel CRM
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  font-white bannerDescription"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Connect with your customers where they are using Pepper Cloud
                omnichannel CRM. Seamlessly integrate messaging channels such as
                WhatsApp, Facebook Messenger, Instagram, WeChat, Telegram, and
                more.
              </motion.p>
              <div className={classes.bannerPoint}>
                {bannerPoints.map((point) => (
                  <div className={classes.banerPointItem}>
                    <img src={bannerTick} />
                    <motion.p
                      className="font-wix-regular font-18 font-white"
                      key={`banner-point-${point}`}
                    >
                      {point}
                    </motion.p>
                  </div>
                ))}
              </div>

              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <div className="parallax-container msgCommunication ">
              <section className="banner-carousel">
                <div className="banner-container">
                  <div className="scroll-container">
                    <div
                      className="logos-row"
                      data-direction="top"
                      data-speed="0.8"
                    >
                      <div className="banner-track">
                        {bannerlogotrack2.map((icon, index) => (
                          <div className="logo font-18 font-wix-medium">
                            <img key={index} src={icon.img} alt={icon.alt} />
                          </div>
                        ))}
                      </div>
                    </div>

                    <div
                      className="logos-row"
                      data-direction="bottom"
                      data-speed="0.8"
                    >
                      <div className="banner-track">
                        {bannerlogotrack3.map((icon, index) => (
                          <div className="logo font-18 font-wix-medium">
                            <img key={index} src={icon.img} alt={icon.alt} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.Client}>
        <div className="container">
          <p className="font-24 font-wix-semibold">
            Trusted by leading businesses for outstanding efficiency
          </p>
          <Swiper
            modules={[Autoplay]}
            className={classes.adaptSlider}
            grabCursor={true}
            loop={true}
            slidesPerView="auto"
            spaceBetween={30}
            speed={6000} // slow speed for smooth flow
            autoplay={{
              delay: 0, // no delay, continuous movement
              disableOnInteraction: false, // keeps looping even on hover/touch
            }}
            freeMode={true} // allows continuous smooth scroll
            freeModeMomentum={false} // disables snapping effect
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 50,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 100,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 100,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 100,
              },
            }}
          >
            {clientList.map((point) => (
              <SwiperSlide className="client-logo">
                <div>
                  <img
                    // alt={point.card.alt}
                    src={point.img}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <section className={classes.broadcastContainer}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black"
            >
              Seamless omnichannel CRM integration
            </motion.h2>
          </div>
        </div>
        <Swiper
          slidesPerView={1}
          centeredSlides={true}
          modules={[Autoplay]}
          speed={5000}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          spaceBetween={30}
          grabCursor={true}
          className={classes.workflowBroadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
              centeredSlides: false,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: "auto",
              centeredSlides: true,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {broadcastList.map((point, index) => (
            <SwiperSlide
              className={classes.broadcastBox}
              style={{ background: point.background }}
            >
              <div className={classes.broadcastLeftContainer}>
                <p className="font-40 font-wix-medium font-white">
                  {point.heading}
                </p>
                <p className="font-18 font-wix-regular font-white mt10 mb20">
                  {point.content}
                </p>
                {point.points.map((content) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      alt={"pointer"}
                      className={clsx(classes.cardPointer)}
                    />
                    <p className="font-wix-regular font-18 font-white">
                      {content}
                    </p>
                  </div>
                ))}
                <a
                  className="loginButton font-wix-medium font-16 mt20"
                  href={point.link}
                >
                  Know more
                </a>
              </div>
              <div className={classes.broadcastRightContainer}>
                <img
                  src={point.img}
                  alt={point.alt}
                  className={classes.broadcastImg}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.benefitSection2}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Why choose Pepper Cloud for CRM communication integration
            </motion.h2>
            {/* <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-18 font-white"
            >
              Using WhatsApp Business Catalog gives your business a competitive
              edge by making product discovery, engagement, and purchase
              seamless—right within a platform your customers already use daily.
            </motion.p> */}
          </div>
          <div className={classes.benefitContainer}>
            {benefits.map((benefit) => (
              <div className={classes.benefitBox}>
                <img src={benefit.icon} alt="Omnichannel CRM" />
                <p className="font-wix-semibold font-24 font-white">
                  {benefit.title}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.experienceContainer} ref={ref}>
        <section className={classes.accordianTabs}>
          <div className="container">
            <div className="headercenterContainer">
              <motion.h2
                className="font-wix-semibold font-56 font-black"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Unlock the potential: Benefits of omnichannel CRM integration
              </motion.h2>
            </div>
            <div className={classes.experienceInnerContainer}>
              <div className={classes.experienceContainerRight}>
                <motion.img
                  style={{ width: "100%", height: "100%" }}
                  initial={{ opacity: 1, y: 20 }}
                  src={experienceImg}
                  alt="How to integrate WhatsApp with CRM"
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                />
              </div>
              <div className={classes.experienceContainerLeft} ref={sectionRef}>
                {experienceList.map((faq, index) => (
                  <motion.div
                    className={clsx(
                      classes.faqBoxAccordian,
                      index === activeAccordian && "active",
                      "text-color2"
                    )}
                    key={`faq-${index}-${activeAccordian === index}`}
                    onClick={() => setActiveAccordian(index)}
                    transition={{ duration: 1, delay: index * 0.01 }}
                    whileInView={{ opacity: [0, 1], y: [50, 0] }}
                  >
                    <div className={classes.experienceHeader}>
                      <h3 className="font-20 font-black font-wix-semibold">
                        {faq.title}
                      </h3>
                    </div>
                    <Collapse
                      className={classes.collapseBody}
                      in={activeAccordian === index}
                    >
                      <p className="font-18 font-wix-regular font-black exp-desc">
                        {faq.desc}
                      </p>

                      {/* <motion.img
                        alt={faq.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={experienceImg}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      /> */}
                    </Collapse>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </section>
      <section className={classes.combineSection}>
        <div className={classes.integrationContent}>
          <motion.h2
            className="font-wix-semibold font-56 color-white"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Pepper Cloud CRM features tailored for business success
          </motion.h2>
        </div>

        <section className="sales-dev-logo-carousel">
          <div className="logos-container">
            <div className="scroll-container">
              <div
                className="logos-row-2"
                data-direction="left"
                data-speed="0.8"
              >
                <div className="logos-track">
                  {logotrack1.map((logo) => (
                    <div
                      className="logo-2 logo font-18 font-wix-medium"
                      key={logo.title}
                    >
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row-2"
                data-direction="right"
                data-speed="0.4"
              >
                <div className="logos-track">
                  {logotrack2.map((logo) => (
                    <div className="logo-2 logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              5 Best software for WhatsApp Business Catalog in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` &&
                        "font-wix-semibold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={"Omnichannel CRM integration - Frequently asked questions"}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Grow with omnichannel CRM integration
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=CRM+email+integration&utm_medium=Show+me+how"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MessagingCommunication;
